import { useEffect, useState } from 'react'
import { useAppSelector } from './redux/redux'

export const useArePointsShownFirstTime = () => {
  const [arePointsShownFirstTime, setArePointsShownFirstTime] = useState(true)
  const { selectedLayers, markersCleared } = useAppSelector(
    (state) => state.layers
  )

  useEffect(() => {
    if (selectedLayers.length || markersCleared) {
      setArePointsShownFirstTime(false)
    } else setArePointsShownFirstTime(true)
  }, [selectedLayers])

  return arePointsShownFirstTime
}
